<template>
<div class="copy-popup-background">
    <div class="copy-popup">
        <div class="copy-popup__body">
            <div class="popup-group" :class="{'disabled-option' : block.two}">
                <div class="popup-group__column">
                </div>
                <div class="popup-group__column">
                    <h1>Kopiuj produkt w celu utworzenia nowego nr artykułu</h1>
                    <div class="row">
                        <div class="col-7">
                            <div class="form-group" :class="{ 'input-error': $v.newProductNumber.number.$error, 'disabled' : newProductNumber.temporary}">
                                <label>nowy numer artykułu*</label>
                                <input class="form-control form-control-lg" type="text" v-model="newProductNumber.number"/>
                                <labelInfo v-if="!$v.newProductNumber.number.required" type="error" message="To pole jest wymagane"/>
                                <labelInfo v-if="!$v.newProductNumber.number.numeric" type="error" message="To pole musi być liczbą"/>
                                <labelInfo v-if="!$v.newProductNumber.number.maxLength" type="error" message="Liczba jest za duża"/>
                            </div>
                        </div>
                        <div class="col-5 col-temporary">
                            <div class="form-group">
                                <label class="checkbox"><input type="checkbox" v-model="newProductNumber.temporary" @click="newProductNumber.number = ''"/><span class="checkmark"></span>Tymczasowy</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="popup-group">
                <div class="popup-group__column">
                </div>
                <div class="popup-group__column">
                    <p v-if="copiedProduct">Produkt został skopiowany</p>
                    <p v-if="noProducts">Nie zaznaczono żadnego produktu</p>
                    <p v-if="toMuch">Wybierz tylko jeden produkt</p>
                    <p v-if="numberExist">Produkt o wybranym numerze artykułu już istnieje w bazie</p>
                    <div class="copy-popup__footer">
                        <button class="button-normal button-normal--media" :class="{'disabled-option' : blockBtn}" @click="copyPageManager()">KOPIUJ</button>
                        <button class="button-normal button-normal--cancel" @click="$emit('canceled')">ANULUJ</button>
                    </div>
                </div>
            </div>
        </div>
      </div>
</div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, numeric, maxLength } from 'vuelidate/lib/validators'
import labelInfo from '@/components/blocks/labelInfo.vue';
import { setTimeout } from 'timers';

export default {

    name: 'copyPopup',
    components:{

        labelInfo

    },
    props:{

        selectedItems:{
            type: Array,
            default: [],
        },

    },
    mixins: [validationMixin],
    data(){

        return{

            copied: false,
            copiedProduct: false,
            noProducts: false,
            noPage: false,
            toMuch: false,
            blockBtn: false,
            numberExist: false,

            newProductNumber:{
                number: '',
                temporary: false,
            },

            orders: [],

            block:{
                two: false,
            }

        }

    },
    validations: {

        newProductNumber: {
            number:{
                isRequired(){
                    return this.isRequired();
                },
                numeric,
                maxLength: maxLength(10)
            },
        },

    },
    methods:{

        isRequired(){

            if(this.newProductNumber.temporary){
                return true;
            }

            if(!this.newProductNumber.temporary && this.newProductNumber.number !=''){
                return true;
            }

            return false;

        },

        copyPageManager(){
            

            this.$v.$touch();

            let valid;

            window.setTimeout(() =>{

                if(document.querySelector('.input-error')){

                    this.blockBtn = false;

                }else{

                valid = true;

                }

                if(valid){

                    this.blockBtn = true;
                    this.checkNumber();
                }

            }, 100)

        },

        checkNumber(){

            let number = {
                    number: this.newProductNumber.number
                }

            const token = localStorage.getItem('auth_token');
            
            this.$http.post(`products/is/exists`, number, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

                if(response.data.message == false){
                    this.numberExist = false;
                    this.newProduct();
                    return;
                }

                this.numberExist = true;
                this.blockBtn = false;

            })
            .catch(error =>{

                console.error(error.response);
                this.numberExist = false;
                this.blockBtn = false;

            })

        },

        newProduct(){

            const token = localStorage.getItem('auth_token');

            if(this.selectedItems.length == 0){
                this.noProducts = true;
                this.blockBtn = false;
                return;
            }

            if(this.selectedItems.length > 1){
                this.toMuch = true;
                this.blockBtn = false;
                return;
            }

            let toCopy = {
                isTemporary: this.newProductNumber.temporary,
                number: this.newProductNumber.number,
            }

            let copiedId;

            this.$http.post(`products/${this.selectedItems[0].id}/copies`, toCopy, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

                this.copiedProduct = true;

                if(this.newProductNumber.temporary){

                   this.newProductNumber.number = response.data.copiedProduct.number
                   
                   setTimeout(() =>{
                    this.$parent.getProducts();
                    this.$parent.$parent.uncheckAllCheckboxes();
                    this.$emit('canceled')
                    }, 2000)

                    return;

                }

                setTimeout(() =>{
                    this.$parent.getProducts();
                    this.$parent.$parent.uncheckAllCheckboxes();
                    this.$emit('canceled')
                }, 1000)

            })
            .catch(error =>{

                console.error(error.response);
                this.blockBtn = false;

            })

        },

    },

}
</script>

<style lang="scss" scoped>

.copy-popup-background{
    display:flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    z-index: 200;
}

.popup-group{
    display:grid;
    grid-template-columns: 7% 87%;

    &__column{
        display:flex;
        flex-direction: column;
    }
}

.copy-popup{
  background:#fff;
  border: 1px #d3020c solid;
  width: 450px;

  &__body{
    padding: 20px 10px;
    position:relative;
    display:flex;
    flex-direction: column;

    & h1{
        font-size: 14px;
        font-weight: 400;
        color:#000000;
        opacity: 1;
    }

    & label{
        font-size: 9px;
        margin-bottom:5px;
    }

     & .form-group{
         width:100%;
     }

    & .form-group.page{
        width:50px;
    }

    & .form-group > input{
        font-size: 14px;
        color:#000000;
        opacity:1;
        font-weight: 400;
    }

    & p{
        font-size: 12px;
        color:#E3000B;
    }

    & .checkbox{
        margin-bottom:0px
    }

  }

  &__footer{
      width:100%;
      display:flex;
      flex-direction: column;

      & button{
          margin-bottom: 15px;
          height:56px;
      }
  }
}

.select-search{
    position: absolute;
    left: 0;
    margin-bottom: -20px;
    width: 100%;
    background: #fff;
    z-index: 3;
    max-height: 400px;
    overflow-x: hidden;
    cursor:pointer;
    visibility: hidden;

    &.active{
        visibility: visible;
    }

    & ul{
        list-style: none;
        padding:0;
        margin:0;

        & li{
            padding:10px 5px;
            &:nth-child(odd){
                background:#edf7ff
            }
        }
    }

    &::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: rgba(226, 229, 235, 0.5);
  }

  &::-webkit-scrollbar{
    width: 5px;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb{
    border-radius: 10px;
    height:50px;
    background-color: #B1B4C1;
  }
}

.disabled-option{
    pointer-events: none;
    opacity: 0.5;
}

.custom-search-input{
    padding-right: 25px;
}

.col-temporary{
    flex-direction: column-reverse;
    display: flex;

    & label{
        font-size: 14px;
    }
}

.form-group.input-error > input {
  height: auto !important;
  padding-bottom: 0 !important;
}

</style>
